import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


const CardSelector = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const cards = location.state?.cards || [];

    const backendURL = process.env.REACT_APP_BACKEND_URL;

    useEffect(() => {
        if (!location.state) navigate('/ocr');
    }, []);

    const getInitials = (card) => {
        if (card.name) {
            return card.name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
        }
        return '?';
    };

    const handleSelect = (card) => {
        navigate('/display', { state: { ocrResult: card } });
    };

    const handleSaveAll = async () => {
        try {
            const results = await Promise.all(
                cards.map(card =>
                    fetch(`${backendURL}db/`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(card)
                    }).then(res => {
                        if (!res.ok) toast.warn("Save failed for one or more cards");
                        return res.json();
                    })
                )
            );

            toast.success(`${results.length} cards' data saved successfully!`);
            navigate('/ocr', { state: "endUser" });

        } catch (error) {
            console.error(error);
            toast.error("Failed to save one or more cards. Please try again.");
        }
    };

    return (
        <>
            <div className="bg-custom-bg bg-cover bg-center min-h-screen flex items-center justify-center px-4">
                <div className="relative z-10 shadow-xl rounded-xl p-8 w-full max-w-2xl">

                    <div className="mb-6">
                        <div className="playwrite text-2xl font-bold text-center text-green-800 mb-1">
                            {cards.length} Card{cards.length !== 1 ? 's' : ''} Found
                        </div>
                        <div className="text-large font-bold text-blue-700 text-center"><i>
                            --- Pick a card to review before saving or save all at once ---</i>
                        </div>
                    </div>

                    {/* Individual Cards */}
                    <div className="space-y-3">
                        {cards.map((card, index) => (
                            <div
                                key={index}
                                onClick={() => handleSelect(card)}
                                className="flex items-center gap-3 p-3 rounded-xl border border-gray-200 hover:border-green-300 hover:bg-green-50 cursor-pointer transition"
                            >
                                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-800 text-sm font-bold flex-shrink-0">
                                    {getInitials(card)}
                                </div>
                                <div className="flex-1 min-w-0">
                                    <p className="font-semibold text-sm text-gray-800 truncate">
                                        {card.name || <span className="text-black font-bold">Unknown name</span>}
                                    </p>
                                    <p className="text-xs text-gray-500 truncate">
                                        {[card.company, card.designation].filter(Boolean).join(' | ') || card.website || ''}
                                    </p>
                                </div>
                                <span className="text-xs text-white border border-gray-200 bg-[#4F7942] rounded-full px-2 py-0.5 whitespace-nowrap">
                                    Card {index + 1}
                                </span>
                                <span className="text-gray-400 text-sm">→</span>
                            </div>
                        ))}
                    </div>

                    <br /><br />

                    {/* Divider */}
                    <div className="flex items-center gap-3 mb-6">
                        <div className="flex-1 h-px bg-gray-200" />
                        <span className="text-xs font-bold text-green-900 whitespace-nowrap">OR</span>
                        <div className="flex-1 h-px bg-gray-200" />
                    </div>

                    {/* Save All Button */}
                    <button
                        onClick={handleSaveAll}
                        className="w-full flex items-center gap-3 p-1 mb-2 rounded-xl border border-green-300 bg-[#095947] hover:bg-green-600 transition text-center"
                    >
                        <div className="flex-1 p-1">
                            <p className="font-bold text-white text-sm">Save all at once</p>
                        </div>
                    </button>

                </div>
                <br />
            </div>
        </>
    );
};

export default CardSelector;